import React, { useRef, useState } from "react";
import { useIntl } from "react-intl";
import { motion } from "framer-motion";
import flagRo from "../../assets/images/flag/flag-ro.svg";
import flagEng from "../../assets/images/flag/flag-eng.svg";
import { useLanguage } from "../../i18n";
import ColorChange from "../change-color/ColorChange";
import { MenuCustomList } from "../menu-custom/MenuCustomList";

const SlideTabs = ({
  homeSectionRef,
  aboutSectionRef,
  rentSectionRef,
  schoolSectionRef,
  driveSectionRef,
  schoolDriveRef,
  contactSectionRef,
}) => {
  const { locale, switchLanguage } = useLanguage();
  const intl = useIntl();
  const [position, setPosition] = useState({ left: 0, width: 0, opacity: 0 });

  // Scroll to the relevant section
  const goTo = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
      {/* Desktop Header */}
      <div className="hidden md:flex fixed top-8 left-1/2 transform -translate-x-1/2 items-center justify-between w-full max-w-screen px-4 z-10">
        <ColorChange />
        <ul
          onMouseLeave={() => setPosition((pv) => ({ ...pv, opacity: 0 }))}
          className="flex w-fit rounded-full border-2 border-black bg-white p-1"
        >
          <Tab setPosition={setPosition} onClick={() => goTo(homeSectionRef)}>
            {intl.formatMessage({ id: "slideTab.home" })}
          </Tab>
          <Tab setPosition={setPosition} onClick={() => goTo(aboutSectionRef)}>
            {intl.formatMessage({ id: "slideTab.aboutUs" })}
          </Tab>
          <Tab
            setPosition={setPosition}
            onClick={() => goTo(rentSectionRef)}
          >
            {intl.formatMessage({ id: "slideTab.drive" })}
          </Tab>
          <Tab setPosition={setPosition} onClick={() => goTo(schoolSectionRef)}>
            {intl.formatMessage({ id: "slideTab.school" })}
          </Tab>
          <Tab setPosition={setPosition} onClick={() => goTo(driveSectionRef)}>
            {intl.formatMessage({ id: "slideTab.rent" })}
          </Tab>
          <Tab
            setPosition={setPosition}
            onClick={() => goTo(schoolSectionRef)}
          >
            {intl.formatMessage({ id: "slideTab.school1" })}
          </Tab>
          <Tab
            setPosition={setPosition}
            onClick={() => goTo(contactSectionRef)}
          >
            {intl.formatMessage({ id: "slideTab.contact" })}
          </Tab>
          <Cursor position={position} />
        </ul>
        <div onClick={() => switchLanguage(locale === "en" ? "ro" : "en")}>
          <img
            src={locale === "en" ? flagEng : flagRo}
            alt="Language Flag"
            style={{ width: "80px", marginRight: "20px", height: "50px" }}
            className="relative w-fit rounded-full border-2 border-black bg-white p-1"
          />
        </div>
      </div>

      {/* Mobile Header - Visible on smaller screens */}
      <div className="md:hidden fixed top-8 left-0 w-full py-0 z-10 border-gray-300 flex items-center justify-between">
        {/* Mobile Menu Toggle Button */}
        {/* You can implement a button here to open/close the mobile menu */}

        {/* Collapsible Mobile Menu */}
        <MenuCustomList  homeSectionRef={homeSectionRef}
        aboutSectionRef={aboutSectionRef}
        rentSectionRef={rentSectionRef}
        schoolSectionRef={schoolSectionRef}
        driveSectionRef={driveSectionRef}
        schoolDriveRef={schoolDriveRef}
        contactSectionRef={contactSectionRef} />
      </div>
    </>
  );
};

// Individual Tab Component
const Tab = ({ children, setPosition, icon, onClick }) => {
  const ref = useRef(null);

  return (
    <li
      ref={ref}
      onMouseEnter={() => {
        if (!ref?.current) return;
        const { width } = ref.current.getBoundingClientRect();
        setPosition({
          left: ref.current.offsetLeft,
          width,
          opacity: 1,
        });
      }}
      onClick={onClick}
      className="relative z-10 flex items-center justify-center cursor-pointer px-3 py-1.5 text-xs uppercase text-white mix-blend-difference md:px-5 md:py-3 md:text-base"
    >
      {icon || children}
    </li>
  );
};

// Cursor Component
const Cursor = ({ position }) => {
  return (
    <motion.li
      animate={{
        ...position,
      }}
      className="absolute z-0 h-7 rounded-full bg-black md:h-12"
    />
  );
};

export default SlideTabs;
